/**
 * Storefinder
 *
 * @author  Meinaart van Straalen
 * @author  Tamara Bazko
 **/
import $ from 'jquery';
import Singleton from 'components/utils/Singleton';
import createLogger from 'components/logger/Logger';
import EventTypes from 'components/EventTypes';
import DirectionsManager from './DirectionsManager';
import MapManager from './MapManager';
import OptionsBar from './OptionsBar';
import StoreList from './List';
import StoreDetails from './StoreDetails';
import Filters from './Filters';
import ResultCounter from './ResultCounter';
import MapSearchManager from './MapSearchManager';
import 'jquery.extendPrototype';

const Logger = createLogger('StoreFinder');

  const $document = document.jq;

  function StoreFinder(settings) {
    Logger.info('Created');
    Logger.time('initialize', this);

    this.settings = $.extend(true, {}, this.settings, settings || {});
    this.$storeFinder = $(this.settings.selector);

    const mapSettings = {
      $storeFinder: this.$storeFinder,
      Map: this.settings.mapApi,
      fullPage: this.settings.fullPage === false ? false : true,
    };

    const moduleSettings = {
      $storeFinder: this.$storeFinder,
    };

    MapManager.initialize(mapSettings);

    if (this.settings.mapSearchApi) {
      const mapSearchSettings = {
        $storeFinder: this.$storeFinder,
        Search: this.settings.mapSearchApi,
      };

      MapSearchManager.attachTo('.js-storeFinder-search', mapSearchSettings);
    }

    if (this.settings.directionsApi) {
      const directionsSettings = {
        $storeFinder: this.$storeFinder,
        Map: this.settings.mapApi,
        Directions: this.settings.directionsApi,
      };

      DirectionsManager.initialize(directionsSettings);
    }

    if (this.settings.Data) {
      this.settings.Data.initialize();
    }

    this.$storeFinder.addClass('is-loading-data');

    if (this.settings.initList) {
      ResultCounter.initialize(moduleSettings);
      OptionsBar.initialize(moduleSettings);
      StoreList.initialize(moduleSettings);
      StoreDetails.attachTo('.js-storeFinder-details', moduleSettings);
    }

    if (this.settings.initFilters) {
      Filters.initialize(moduleSettings);
    }

    this.bindEvents();
    this.$storeFinder.trigger(EventTypes.STOREFINDER_INITIALIZED);
    Logger.timeEnd('initialize', this);
  }

  $.extendPrototype(StoreFinder, {
    $storeFinder: undefined,
    Map: undefined,
    settings: {
      selector: '.js-storeFinder',
      initList: true,
      initFilters: true,
      fullPage: true,
    },

    /**
     * Bind event listeners
     */
    bindEvents() {
      $document
        .one(EventTypes.STOREFINDER_MAP_INITIALIZED, this.onMapInitialized.bind(this))
        .one(EventTypes.STOREFINDER_MAP_FAILED, this.onMapFailed.bind(this))
        .on(EventTypes.STOREFINDER_GET_STORES, this.onGetStores.bind(this))
        .on(EventTypes.STOREFINDER_GET_STORES_REQUEST, this.onGetStoresRequest.bind(this));
    },

    /**
     * Remove `is-loading-data` class to storefinder when stores are loaded
     */
    onGetStores() {
      this.$storeFinder.removeClass('is-loading-data');
    },

    /**
     * Add `is-loading-data` class to storefinder when stores are being loaded
     */
    onGetStoresRequest() {
      this.$storeFinder.addClass('is-loading-data');
    },

    /**
     * Event listener for when Google Maps or Sogou Maps API fail to load
     */
    onMapFailed() {
      this.$storeFinder.removeClass('is-loading').addClass('has-error');
      this.$storeFinder
        .find('.js-storeFinder-bar-optionsBar')
        .html(window.labels.storeFinder.errorMessageLoad);
    },

    /**
     * Remove loading state when map has loaded
     */
    onMapInitialized() {
      this.$storeFinder.removeClass('is-loading');
    },
  });

export default Singleton.create(StoreFinder, 'StoreFinder');
